<template>
  <div>
    <div class="container-carousel-full">
      <slider :photosNumber="numberPhotos" :labelImageToShow="labelImageToShow"></slider>
    </div>
  </div>
</template>

<script>
import Slider from "@/components/slider/Slider.vue";

export default {
  name: "CarouselImages",

  components: { Slider },

  props: ["numberPhotos", "labelImageToShow"]
};
</script>
<style>
.container-carousel-full {
  padding: 10px 25px;
  padding-bottom: 60px;
}

@media (max-width: 833px) {
  .container-carousel-full {
    padding-bottom: 50px;
  }
}
</style>
